import React, { Component } from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa'

class Projects extends Component {
    render() {

        const [parentState, parentSetState, index] = this.props.state
        const project = parentState.find(item => item.id === index)
        return (
            <div className="workContainer">

                <Form>
                    <div>
                        <Form.Row>
                            <Form.Group as={Col} lg={7} md={6} controlId="formGridEmail">
                                <Form.Label>Project Name</Form.Label>
                                <Form.Control
                                    value={project.name}
                                    onChange={(e) => {
                                        const newState = [...parentState]
                                        const modIndex = newState.findIndex(item => item.id === index)
                                        newState[modIndex].name = e.target.value
                                        parentSetState({ project: newState })
                                    }}

                                    type="text" required placeholder="eg. Project Name" />
                            </Form.Group>

                            <Form.Group as={Col} lg={5} md={6} controlId="formGridEmail">
                                <Form.Label>Project Link</Form.Label>
                                <Form.Control
                                    value={project.link}
                                    onChange={(e) => {
                                        const newState = [...parentState]
                                        const modIndex = newState.findIndex(item => item.id === index)
                                        newState[modIndex].link = e.target.value
                                        parentSetState({ project: newState })
                                    }}
                                    type="text" required placeholder="eg. Link to your project" />
                            </Form.Group>

                        </Form.Row>

                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Describe About the Project</Form.Label>
                            <Form.Control
                                value={project.desc}
                                onChange={(e) => {
                                    const newState = [...parentState]
                                    const modIndex = newState.findIndex(item => item.id === index)
                                    newState[modIndex].desc = e.target.value
                                    parentSetState({ project: newState })
                                }}
                                as="textarea" rows="3" placeholder="eg. So my project is based ......" />
                        </Form.Group>
                    </div>
                    <Button
                        onClick={this.props.deleteHandler}
                        variant="danger" size="sm">
                        <FaTrash />
                    </Button>
                </Form>
            </div>
        )
    }
}

export default Projects;